module.exports = "pegasus/assets/blocks/column-16-theme5.png";